import { apiFactory } from "services/ApiFactory";
import { applicationsRole } from "utils/permissionConstants";
import { checkNull, handleNullArray, isObjectNull } from "utils/utils";

const getUserAccessDetail = async (userProfileId, applicationId, applicationComponentId) => {
  let tempPermission = {
    isUserSystemAdministrator: false,
    isUserSubSystemAdministrator: false,
    permissions: [],
    hasError: false,
    error: "",
  };


  try {
    let isUserSystemAdministrator = (
      await apiFactory.intranetApiFactory.authorization.isUserSystemAdministrator(
        userProfileId
      )
    ).data;

    let isUserSubSystemAdministrator = (
      await apiFactory.intranetApiFactory.authorization.isUserSubSystemAdministrator(
        userProfileId,
        applicationId
      )
    ).data;

    if (
      isUserSystemAdministrator === true ||
      isUserSubSystemAdministrator === true
    ) {
      tempPermission = {
        ...tempPermission,
        isUserSystemAdministrator,
        isUserSubSystemAdministrator,
      };
    } else {
      tempPermission = {
        ...tempPermission,
        permissions: (
          await apiFactory.intranetApiFactory.authorization.getApplicationPermission(
            userProfileId,
            applicationId,
            applicationComponentId
          )
        ).data.personnelPermissions
      };
    }

    return tempPermission;
  } catch (error) {
    return {
      isUserAdmin: false,
      permissions: [],
      error: error,
    };
  }
};

const getUserSpecificRoleByApplicationId = async (
  userProfileId,
  applicationId,
  roleId
) => {

  let userAccessDetails = await getUserAccessDetail(
    userProfileId,
    applicationId
  );

  return userAccessDetails.permissions.find(
    (cond) =>
      cond.applicationId === applicationId &&
      cond.roleId === roleId);
};

const hasValueItem = (items, item, key) => {
  return handleNullArray(items).some(cond => cond[key] === item);        
}

const hasUserSpecificAccess = async (userId, roleId) => {
  let resultItem = await getUserSpecificRole(userId, roleId);
  return !isObjectNull(resultItem);
};

const getUserFullAuthorization = async userId => {
  let userFullAuthorization = (
    await apiFactory.intranetApiFactory.authorization.getUserFullAuthorization(
      userId
    )
  ).data;

  if (!checkNull(userFullAuthorization) && !checkNull(userFullAuthorization.roleMembers)) {
    return userFullAuthorization.roleMembers;
  }

  return [];
}

const getUserSpecificRole = async (userId, roleId) => {
  try {
    let specificRoleData = (
      await apiFactory.intranetApiFactory.authorization.getPersonnelRoles(
        userId
      )
    ).data;

    return specificRoleData.find((cond) => cond.roleId === roleId);
  } catch (error) {
    return {
      isUserAdmin: false,
      permissions: [],
      error: error,
    };
  }
};


export default function UseGetUserAccessDetail() {
  return {
    getUserAccessDetail: async (userId, applicationId, applicationComponentnId) =>
      await getUserAccessDetail(userId, applicationId, applicationComponentnId),
    getUserSpecificRoleByApplicationId: (userId, applicationId, roleId) =>
      getUserSpecificRoleByApplicationId(userId, applicationId, roleId),
    getUserSpecificRole: (userId, roleId) =>
      getUserSpecificRole(userId, roleId),
    getUserFullAuthorization: (userId) => 
      getUserFullAuthorization(userId),
    hasUserSpecificAccess: (userId, roleId) =>
      hasUserSpecificAccess(userId, roleId),
    hasValueItem: (items, item, key) => hasValueItem (items, item, key),
  };
}